let startTime = null
let scrollDepth = 0
let intervalId = null
let active = false

function onScroll() {
  if (typeof window === 'undefined') return
  const docHeight = document.documentElement.scrollHeight - window.innerHeight
  if (docHeight <= 0) return
  const pct = Math.round((window.scrollY / docHeight) * 100)
  if (pct > scrollDepth) scrollDepth = pct
}

function start() {
  if (active || typeof window === 'undefined') return
  active = true
  startTime = Date.now()
  scrollDepth = 0
  window.addEventListener('scroll', onScroll, { passive: true })
}

function stop() {
  if (!active || typeof window === 'undefined') return
  active = false
  window.removeEventListener('scroll', onScroll)
  if (intervalId) {
    clearInterval(intervalId)
    intervalId = null
  }
}

function getCartItemCount() {
  if (typeof window === 'undefined') return 0
  try {
    const raw = localStorage.getItem('cart')
    if (!raw) return 0
    const cart = JSON.parse(raw)
    if (Array.isArray(cart)) return cart.length
    if (cart?.items) return cart.items.length
    return 0
  } catch {
    return 0
  }
}

function getPageLanguage() {
  if (typeof window === 'undefined') return 'en'
  const match = window.location.pathname.match(/^\/([a-z]{2})(\/|$)/)
  return match ? match[1] : 'en'
}

function snapshot() {
  const dwellSeconds = startTime ? Math.round((Date.now() - startTime) / 1000) : 0
  return {
    pageUrl: typeof window !== 'undefined' ? window.location.pathname : '',
    language: getPageLanguage(),
    scrollDepth,
    dwellSeconds,
    referrer: typeof document !== 'undefined' ? document.referrer : '',
    cartItemCount: getCartItemCount(),
  }
}

export default { start, stop, snapshot }
